'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Checkbox from '../inputs/Checkbox';

const CertifiedToggle = ({
  onChange,
  value
}) => {
  return /*#__PURE__*/_jsx(Checkbox, {
    checked: value === true,
    name: "certified",
    onChange: ({
      target: {
        checked
      }
    }) => onChange(checked),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.filters.certified.item"
    })
  });
};

CertifiedToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool
};
export default CertifiedToggle;